module.exports = __webpack_public_path__ + "img/1571208591.6acb94c6.jpg";